import React from "react";
import { WarningDialog } from "@graffer-inc/console-design-kit";

interface ArchiveDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  rulesetName: string;
}

export const ArchiveDialog: React.FC<ArchiveDialogProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  rulesetName,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <WarningDialog
      title="申請振り分け設定のアーカイブ"
      contents={`「${rulesetName}」をアーカイブしますか？アーカイブ後は復元できません。`}
      proceedText="アーカイブ"
      cancelText="キャンセル"
      onProceed={onConfirm}
      onCancel={onCancel}
    />
  );
};
